<ng-container *ngIf="option.numberOfAdults">
  <div class="d-flex justify-content-between">
    <p class="title">Price per adult</p>
    <p [innerHTML]="option.soldAmountPerAdult | portalCurrency" data-id="sold-amount-per-adult"></p>
  </div>

  <div class="d-flex justify-content-between mt-1">
    <p class="title">Number of adults</p>
    <p data-id="number-of-adults">{{ option.numberOfAdults }}</p>
  </div>

  <hr class="my-2 hr" />
</ng-container>

<ng-container *ngIf="option.numberOfChildren">
  <div class="d-flex justify-content-between">
    <p class="title">Price per child</p>
    <p [innerHTML]="option.soldAmountPerChild | portalCurrency" data-id="sold-amount-per-child"></p>
  </div>

  <div class="d-flex justify-content-between mt-1">
    <p class="title">Number of children</p>
    <p data-id="number-of-children">{{ option.numberOfChildren }}</p>
  </div>

  <hr class="my-2 hr" />
</ng-container>

<ng-container *ngIf="option.numberOfInfants">
  <div class="d-flex justify-content-between">
    <p class="title">Price per infant</p>
    <p
      [innerHTML]="option.soldAmountPerInfant | portalCurrency"
      data-id="sold-amount-per-infant"
    ></p>
  </div>

  <div class="d-flex justify-content-between mt-1">
    <p class="title">Number of infants</p>
    <p data-id="number-of-infants">{{ option.numberOfInfants }}</p>
  </div>

  <hr class="my-2 hr" />
</ng-container>

<div class="d-flex justify-content-between">
  <p class="title">Total price</p>
  <p [innerHTML]="option.flightsTotal | portalCurrency" data-id="total"></p>
</div>
